export default {"src":"/_next/static/media/course-replay.aae541f0.svg","height":28,"width":28};